import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

import { DataService } from '../../shared-service/data.service';
import { BaseService } from '../../shared-service/base.service';

declare var $: any;

@Component({
  selector: 'app-esign',
  templateUrl: './esign.component.html',
  styleUrls: ['./esign.component.css']
})
export class EsignComponent implements OnInit, AfterViewInit {

  @Output() acceptClick = new EventEmitter<object>();
  itemData: object|any;
  @Input() scope: string = "";
  AcceptLabel :string = "";

  options: object = {
    keyboard: true,
    backdrop: true,
    show: true
  }
  esignImage: string = "";
  IsESignImageExist: boolean = false;
  theCheckbox: boolean = false;

  IsAccepted: boolean = false;


  constructor(public dataService: DataService, public bs: BaseService) { }

  ngOnInit() {
    this.esignImage = this.bs.getUserAttr("UserESignImage");
    this.AcceptLabel = this.bs.getResource('rbkey_AccptEsignLbl');
  }

  ngAfterViewInit() {
    //In Initial disable the Submit button 
    $("#btnAccept" + this.scope).prop("disabled", "disabled");
    $("#btnAccept" + this.scope).css("background", "#eee");
    //To handle error "Expression has changed after it was checked" for IsESignImageExist
    setTimeout(() => {
      if (this.esignImage == "") {
        //If esign image not exist then disable the Checkbox
        this.IsESignImageExist = false;
        $("#chkAccept" + this.scope).prop("disabled", "disabled");
      }
      else {
        this.IsESignImageExist = true;
        $("#chkAccept" + this.scope).prop("disabled", false);

      }
    });
    
    $("#esignModal" + this.scope).on('hide.bs.modal', function () {
      $("#chkAccept" + this.scope).prop("checked", false);
      $("#btnAccept" + this.scope).prop("disabled", "disabled");
      $("#btnAccept" + this.scope).css("background", "#eee");
    });
  }

  openModelPopup(itemData: object,IsAnnouncement:boolean) {  
    this.esignImage = this.bs.getUserAttr("UserESignImage");
    this.itemData = itemData;
    $('#esignModal' + this.scope).modal(this.options);
    if (this.scope == "SysAlrtAnnDtl") {
      $('#esignModal' + this.scope).css("position", "relative");
    }
    if(IsAnnouncement)
    this.AcceptLabel = this.bs.getResource('rbkey_IRdAndAccptLBL');
  }

  IsEsignPopupOpen(): boolean {       
    return $('#esignModal' + this.scope).is(':visible');
  }

  closePanel() {
    $('#esignModal' + this.scope).modal('hide');
    $("#chkAccept" + this.scope).prop("checked", false);
    $("#btnAccept" + this.scope).prop("disabled", "disabled");
    $("#btnAccept" + this.scope).css("background", "#eee");
  }

  enableSubmitButton(e:any) {
    this.theCheckbox = e.target.checked;
    if (!this.theCheckbox) {
      $("#btnAccept" + this.scope).prop("disabled", "disabled");
      $("#btnAccept" + this.scope).css("background", "#eee");
    }
    else {
      $("#btnAccept" + this.scope).prop("disabled", false);
      $("#btnAccept" + this.scope).css("background", "#ffffff");
    }
  }

  acknowledgeEsign() {
    this.IsAccepted = $("#chkAccept" + this.scope).prop("checked");
    if (this.IsAccepted) {
      $("#chkAccept" + this.scope).prop("checked", false);
      this.acceptClick.emit(this.itemData);
    }
    else
      alert(this.bs.getResource('rbkey_AlrtEsignAccpt'));

  }

}
